import { stringify } from 'qs'
import api from './api'
import { pick } from '@/lib/helpers'

function dataProvider(resource, actions = []) {
	// Create resource base route
	const base = `/${resource}`

	// Define all possible provider actions
	const availableActions = {
		list: query => {
			const qs = stringify(query)
			return api.get(base + (qs ? `?${qs}` : ''))
		},
		get: id => api.get(`${base}/${id}`),
		create: body => api.post(base, body),
		update: (id, body) => api.patch(`${base}/${id}`, body),
	}

	if (actions.length) {
		// Limit which actions are attached to the provider
		return pick(availableActions, ...actions)
	} else {
		// Attach all actions
		return availableActions
	}
}

export const EventProvider = dataProvider('event')
export const UserProvider = dataProvider('user', ['get', 'update'])
export const StatsProvider = dataProvider('stats', ['get'])
export const LeaderboardsProvider = dataProvider('leaderboards', ['get'])
